import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
document.title = 'Bedford | Scale operations without scaling headcount';
render(<App data-id="element-369" />, document.getElementById('root'));